import { useMutation, useQuery } from "@tanstack/react-query"
import { IPatient, PatientPostBody } from "../types/types"
import { apiFetchProtected } from "../utils/api"

export const usePatchPatient = (patient_id: number) =>
  useMutation({
    mutationFn: (patient: PatientPostBody) =>
      apiFetchProtected(`/patients/${patient_id}`, {
        method: "PATCH",
        body: patient
      }),
    onError: (error) => {
      console.error("Error:", error)
    }
  })

export const usePatient = (patientId: number | undefined) =>
  useQuery({
    queryKey: ["patient", patientId],
    queryFn: () => fetchPatient(patientId),
    enabled: !!patientId
  })

const fetchPatient = async (patientId: number | undefined): Promise<IPatient> =>
  await apiFetchProtected<IPatient>(`/patients/${patientId}`, {})
